import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("ft_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.response ? "Something went wrong. Please try again." : "Can't reach FollowThrough. Check your connection.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x?.msg ? x.msg.replace(/^Value error, /, "") : JSON.stringify(x))).join(" ");
  return d.msg || String(d);
}

export const imgUrl = (p) => (!p ? null : p.startsWith("http") ? p : `${API}/files/${p}`);

export const money = (v) =>
  v == null ? "" : `$${Number(v).toLocaleString(undefined, { maximumFractionDigits: Number(v) % 1 ? 2 : 0 })}`;

export const CATEGORY_LABELS = {
  furniture: "Furniture", electronics: "Electronics", home_goods: "Home goods",
  clothing: "Clothing", sporting_goods: "Sporting goods", tools: "Tools", vehicles: "Vehicles",
};
export const vehicleLine = (v) => (v ? `${v.year} ${v.make} ${v.model} · ${Number(v.mileage).toLocaleString()} mi` : "");
export const CONDITION_LABELS = {
  new: "New", like_new: "Like new", good: "Good", fair: "Fair", for_parts: "For parts",
};

export const fmtDate = (s) => new Date(s).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
export const fmtDateTime = (s) =>
  `${new Date(s).toLocaleString(undefined, { weekday: "short", month: "short", day: "numeric", hour: "numeric", minute: "2-digit", timeZone: "America/Los_Angeles" })} PT`;
const PT_FMT = { timeZone: "America/Los_Angeles", hour12: false, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit" };
const ptWall = (d) => d.toLocaleString("sv-SE", PT_FMT).replace(" ", "T");
export const isoToPtWall = (iso) => (iso ? ptWall(new Date(iso)).slice(0, 16) : "");
export const ptWallToIso = (wall) => {
  const guess = new Date(`${wall}:00Z`);
  const diff = new Date(`${ptWall(guess)}Z`).getTime() - guess.getTime();
  return new Date(guess.getTime() - diff).toISOString();
};
export const timeAgo = (s) => {
  const m = Math.round((Date.now() - new Date(s).getTime()) / 60000);
  if (m < 1) return "just now";
  if (m < 60) return `${m}m ago`;
  if (m < 1440) return `${Math.round(m / 60)}h ago`;
  return `${Math.round(m / 1440)}d ago`;
};
export const fmtMinutes = (m) => (m < 60 ? `${m} min` : m < 1440 ? `${Math.round(m / 60)} hr` : `${Math.round(m / 1440)} days`);
